module.exports = __webpack_public_path__ + "static/Inbound_Marketing-39b644578319072ca5e706399ebda350.svg";